export const MantineThemeColors = [
  'primary',
  'accent',
  'blue',
  'red',
  'green',
  'pink',
  'grape',
  'violet',
  'indigo',
  'cyan',
  'teal',
  'lime',
  'yellow',
  'orange',
  'gray',
] as const;
